export default __webpack_public_path__ + "static/media/screen14.1edb9847.svg";